import { useEffect, useRef } from 'react';

export function useClickOutside(ref, enabled, onOutside) {
  const onOutsideRef = useRef(onOutside);

  useEffect(() => {
    onOutsideRef.current = onOutside;
  }, [onOutside]);

  useEffect(() => {
    if (!enabled) return;

    const handler = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideRef.current(event);
      }
    };

    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [enabled, ref]);
}

// Escape closes the same popovers useClickOutside dismisses by mouse.
export function useEscapeKey(enabled, onEscape) {
  const onEscapeRef = useRef(onEscape);

  useEffect(() => {
    onEscapeRef.current = onEscape;
  }, [onEscape]);

  useEffect(() => {
    if (!enabled) return;

    const handler = (event) => {
      if (event.key === 'Escape') onEscapeRef.current(event);
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [enabled]);
}
